import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import {observable} from "mobx";
import {CancelStates} from "../CancelStates";
import {ICancelPlanRequest} from "../../../../../../shared/src/functions/membersApi/types/IPlanRequests";
import FirebaseMyAccountService from "../../../../services/firebase/functions/FirebaseMyAccountFunctionsService";
import {MyAccountStores} from "../../../MyAccount/state/mobx";

const accountStore = MyAccountStores.accountUserStore;


export class CancelPlanFormStore extends ApiCallObservable {

    @observable public files: any = {};
    @observable public formInput: any = {};
    @observable public navigationController = {};
    @observable public _isModalOpen: boolean = false;
    @observable private _isFormFinish: boolean = false;
    @observable private _currentScreen: CancelStates = CancelStates.welcome;


    get currentScreen() {
        return this._currentScreen;
    };

    get allowFinishForm() {
        return this._isFormFinish;
    };

    get isModalOpen() {
        return this._isModalOpen;
    };

    public updateFinishForm = (value: boolean) => {
        this._isFormFinish = value;
    };

    public updateScreen = (screen: CancelStates) => {
        this._currentScreen = screen;
    };

    public updateModalStatus = (val: boolean) => {
        this._isModalOpen = val;
    };

    public async cancelPlan() {
        if(!accountStore.selectedPlan) {
            console.log("error");
            return;
        }
        try {
            this.setSending();
            this.formInput.cancellation.planId = accountStore.selectedPlan!.id;
            const cancellationParams: ICancelPlanRequest = this.formInput.cancellation;
            const response = await FirebaseMyAccountService.cancelPlan(cancellationParams);
            if (response.ok) {
                this.setSuccessfulResponse(response.data);
                this.updateScreen(CancelStates.finish);
            } else {
                console.log(response);
                this.setError("Failed fetching summary");
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/CancelPlanStore.ts